export const classes = {
    pre: 'Pre-judo', 
    youth: 'Youth', 
    adult: 'Teen/Adult'
}

//Small (smaller than 640px)
//Medium (641px to 1007px)
//Large (1008px and larger)
